import { render, staticRenderFns } from "./ApopUserMenu.vue?vue&type=template&id=4a5afe24&"
import script from "./ApopUserMenu.vue?vue&type=script&lang=js&"
export * from "./ApopUserMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports